import React, { useState, useEffect } from 'react';
import styles from './style.module.scss';
import { FaRegCalendarAlt, FaStar, FaCrown } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { api } from '../../services/apiClient';

const BoloesHome = ({ boloes }) => {
  const navigate = useNavigate();
  const [dataRanking, setDataRankin] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchRanking();
  }, []);

  const fetchRanking = async () => {
    try {
      setLoading(true);
      const response = await api.get('/jogos_especial_get');
      setDataRankin(response.data);
    } catch (error) {
      console.error('Erro ao buscar dados da API:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const options = { month: '2-digit', day: '2-digit' };
    return new Date(dateString).toLocaleDateString('pt-BR', options);
  };

  const hexToRGBA = (hex, opacity) => {
    hex = hex.replace('#', '');
    if (hex.length === 3) {
      hex = hex
        .split('')
        .map((hexChar) => hexChar + hexChar)
        .join('');
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  const isToday = (dateString) => {
    const today = new Date();
    const date = new Date(dateString);
    return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
  };

  const formatPrize = (value) => {
    console.log('value', value)
    if (!value) return { number: '0', word: '' };

    let numberPart;
    let wordPart = '';

    if (value >= 999999999) {
      numberPart = (value / 999999999).toFixed(1);
      numberPart = numberPart.endsWith('.0') ? numberPart.slice(0, -2) : numberPart;
      wordPart = parseFloat(numberPart) > 1 ? 'Bilhões' : 'Bilhão';
    } else if (value >= 1_000_000) {
      numberPart = (value / 1_000_000).toFixed(1);
      numberPart = numberPart.endsWith('.0') ? numberPart.slice(0, -2) : numberPart;
      wordPart = parseFloat(numberPart) > 1 ? 'Milhões' : 'Milhão';
    } else if (value >= 1_000) {
      numberPart = (value / 1_000).toFixed(1);
      numberPart = numberPart.endsWith('.0') ? numberPart.slice(0, -2) : numberPart;
      wordPart = 'Mil';
    } else {
      numberPart = value.toString();
    }

    return { number: numberPart, word: wordPart };
  };

  const handleBetClick = (id) => {
    navigate(`/bolao/${id}`);
  };

  // Ordena os bolões para que os especiais apareçam primeiro
  const sortedBoloes = [...boloes].sort((a, b) => b.especial - a.especial);

  const LoadingSpinner = () => (
    <div className={styles.loadingContainer}>
      <div className={styles.spinner}></div>
      <p>Carregando bolões...</p>
    </div>
  );

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Participe dos bolões mais inteligentes e fique ainda mais perto do seu sonho!</h1>
        <h3>Nossos bolões possuem alta chance de premiação e estão alinhados com as estatísticas de cada loteria. Escolha o seu e faça sua aposta!</h3>
      </div>

      {(!boloes || boloes.length === 0) && <LoadingSpinner />}

      <div className={styles.boloesGrid}>
        {sortedBoloes.map((bolao) => (
          <div key={bolao.id} className={styles.cardWrapper}>
            <div
              className={`${styles.card} ${bolao.especial === 1 ? styles.especialCard : ''}`}
              style={{
                '--card-color': bolao.cor,
                '--card-bg': hexToRGBA(bolao.cor, 0.08),
                '--card-border': hexToRGBA(bolao.cor, 0.2),
              }}
            >
              {/* {bolao.especial === 1 && (
                <div className={styles.especialBadge}>
                  <FaCrown />
                  <span>ESPECIAL</span>
                </div>
              )} */}

              <div className={styles.headerCard} style={{ backgroundColor: bolao.cor }}>
                <h2 className={styles.cardTitle}>{bolao.nome}</h2>
                {bolao.especial === 1 && (
                  // <div className={styles.starDecoration}>
                  //   <FaStar />
                  //   <FaStar />
                  //   <FaStar />
                  // </div>
                  <div className={styles.especialBadge}>
                    <FaCrown />
                    <span>ESPECIAL</span>
                  </div>
                )}
              </div>

              <div className={styles.cardContent}>
                {bolao.acumulou === 1 && (
                  <div className={styles.acumulado} style={{ borderColor: bolao.cor, color: bolao.cor }}>
                    <span>🔥 Acumulado</span>
                  </div>
                )}

                {isToday(bolao.data_sorteio) && (
                  <div className={styles.bolaoHoje}>
                    <span>⚡ Hoje</span>
                  </div>
                )}

                <div className={styles.containerValor}>
                  <div className={styles.prizeContainer}>
                    <span className={styles.currencySymbol}>R$</span>
                    <span className={styles.cardValue} style={{ color: bolao.cor }}>
                      {formatPrize(bolao.premiacao).number}
                    </span>
                  </div>
                  <div className={styles.cardUnit} style={{ color: bolao.cor }}>
                    {formatPrize(bolao.premiacao).word}
                  </div>
                </div>

                <div className={styles.containerDadosConc} style={{ backgroundColor: hexToRGBA(bolao.cor, 0.05) }}>
                  <div className={styles.concursoInfo}>
                    <span className={styles.cardDate}>Concurso: {bolao.concurso}</span>
                  </div>
                  <div className={styles.dateInfo}>
                    <FaRegCalendarAlt />
                    <span>{formatDate(bolao.data_sorteio)}</span>
                  </div>
                </div>

                <button className={styles.betButton} onClick={() => handleBetClick(bolao.id)} style={{ backgroundColor: bolao.cor }}>
                  <span>Ver Bolões</span>
                  <div className={styles.buttonGlow}></div>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BoloesHome;
